import { ConversationDetails } from "@virtualprogaming/js-public-sdk";
import { AxiosResponse } from "axios";
import { isFunction } from "lodash";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { useChatApi } from "./useChatApi";

export function useChatConversationMarkUnread(
  options?: UseMutationOptions<
    AxiosResponse<ConversationDetails>,
    unknown,
    [number, string]
  >
) {
  const api = useChatApi();
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options || {};
  return useMutation((vars) => api.markConversationUnread(...vars), {
    onSuccess: async (data, vars, ctx) => {
      isFunction(onSuccess) && onSuccess(data, vars, ctx);
      await queryClient.invalidateQueries(["chat-conversation-messages"]);
      await queryClient.invalidateQueries(["chat-conversations"]);
    },
    ...rest,
  });
}
